export class AssetOpExportOtp {
    documentType: string;
    assetName: string;
    assetinvNo: string;
    quantity: number;
    assetValueInv: number;
    costCenterCodeInitial: string;
    costCenterNameInitial: string;
    costCenterCodeFinal: string;
    costCenterNameFinal: string;
    modifiedAt: Date;
}